import { ofType } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformResponse } from './transform';

import {
    RESET,
    SET as patientSET
} from 'one-state-subject/src/types';

import {
    setAction,
    reinitAction
} from 'one-state-interactions/src/actions';

import {
    setAction as setSkeletonAction
} from 'one-state-skeleton';
import { Disposition } from 'one-model-local';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import {format} from 'one-util-date';


export const enum Types {
    SETCALLERINTERACTIONS = 'one-state-interactions/fetch',
    STORE_DISPOSITION_CODE = "store-disposition-code",
}

const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });

/**
 * This Fuction will fetch the data of interactions epic
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */

export const fetchInteractionsEpic = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(),'LT');
        const errorDate = format(new Date(),'LL');
        const { log, server, agentId,teamName, settings: {
            epicendpoints: {
                getinteractions,
                apitoken
            }, 
            compatible,
            uisettings: {
                dashboardapiconfig: {
                    getinteractions : getinteractionsApi
                }
            },
        }} = context;
        const { contact_center_type } = compatible;
        return action$.pipe(
           ofType(Types.SETCALLERINTERACTIONS),
            //todo: to fix the type of Action
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the Interactions Response
                 */

                let dataresponse: any = action.payload;
                const getRequest = (datares: any) => {
                    
                    if (datares) {
                        let headers = new Headers();
                        // todo: need to refractor to include authorization in interface
                        headers.set('Authorization', 'Basic ' + apitoken?.token);
                        const data = {
                            sysparm_query: `opened_for.email=${datares.email}`,
                            sysparm_display_value: true,
                            sysparm_exclude_reference_link: true,
                            sysparm_fields: 'sys_id,number,short_description,type,state,opened_for,assigned_to,caller_id,sys_created_on,assigned_to display_value,task',
                          }
                        const response = server.post({
                            path: getinteractions,
                            data: data,
                            headers: headers
                        })
                            .then((responsefound: any) => responsefound)
                            .catch((responseresult: any) => {
                                log.error(
                                    "ccw-gadget,interactions-epic",
                                    "fetch-Interactions-epic", {
                                    responseresult
                                }
                                );

                                let errorbuild: ErrorObject = {
                                    source: "Interactions",
                                    type: "error",
                                    status: responseresult?.status,
                                    erroritems: responseresult?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return errorbuild;
                            })
                        return from(response)
                    } else {
                        return from([]);
                    }
                }
                //Calling getRequst function here
                //the reason is we need to use pipe function.
                if(!getinteractionsApi)  return []
                return getRequest(dataresponse).
                    pipe(
                        map((response: any) => TransformResponse(response, context))).
                    pipe(
                        flatMap(response => {
                            
                            const actions: any = [
                                setAction(response)];
                            if (response.error) {
                                actions.push(addAction(response.error));
                                
                            }
                            if(response?.error){
                                /*changes for errors will pushed to bell icon*/
                                     let errorbuild:ErrorObject = {
                                    source: "SN-Interactions",
                                    type: "error",
                                    status: response?.status,
                                    erroritems: response?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                actions.push(addAction(errorbuild))
                                let disp: Disposition = { value: "1012" }
                                 if (contact_center_type && contact_center_type === 'five9') {
                                     let agentIdValue = sessionStorage.getItem("agentName");
                                     let skillName = sessionStorage.getItem("skillName");
                                     disp.meta00 = agentIdValue;
                                     disp.meta01 = skillName;
                                     disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                 } 
                                 else if(contact_center_type==="genesys"){
                                    disp.meta00 = sessionStorage.getItem("name");
                                    disp.meta01 = sessionStorage.getItem("agentName");
                                  }
                                  else if(contact_center_type==="twilio"){
                                    disp.meta00 = sessionStorage.getItem("twilio_userid");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="ringcentral"){
                                    disp.meta00 = sessionStorage.getItem("ringcentral_agentName");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="inContact"){
                                    disp.meta00 = sessionStorage.getItem("agentName");
                                    disp.meta01 = sessionStorage.getItem("Incontact_SkillName");
                                  }
                                  else if(contact_center_type==="vonage"){
                                    disp.meta00 = sessionStorage.getItem("vonage_userid");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="wxcc"){
                                    disp.meta00 = sessionStorage.getItem("wxcc_agentId");
                                    disp.meta01 = "";
                                  } 
                                 else {
                                     disp.meta00 = agentId;
                                     disp.meta01 = teamName
                                     disp.dial_list_uid = state$.value.choosecaller?.callId;
                                 }
                                 disp.meta03 = response?.error?.status;
                                 disp.meta02 = dataresponse.opened_for;
                                 actions.push(pushToDisposition(disp));
                                 } else {
                                     let disp: Disposition = { value: "196" }
                                     if (contact_center_type && contact_center_type === 'five9') {
                                         let agentIdValue = sessionStorage.getItem("agentName");
                                         let skillName = sessionStorage.getItem("skillName");
                                         disp.meta00 = agentIdValue;
                                         disp.meta01 = skillName;
                                         disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                     } 
                                     else if(contact_center_type==="genesys"){
                                        disp.meta00 = sessionStorage.getItem("name");
                                        disp.meta01 = sessionStorage.getItem("agentName");
                                      }
                                      else if(contact_center_type==="twilio"){
                                        disp.meta00 = sessionStorage.getItem("twilio_userid");
                                        disp.meta01 = "";
                                      }
                                      else if(contact_center_type==="ringcentral"){
                                        disp.meta00 = sessionStorage.getItem("ringcentral_agentName");
                                        disp.meta01 = "";
                                      }
                                      else if(contact_center_type==="inContact"){
                                        disp.meta00 = sessionStorage.getItem("agentName");
                                        disp.meta01 = sessionStorage.getItem("Incontact_SkillName");
                                      }
                                      else if(contact_center_type==="vonage"){
                                        disp.meta00 = sessionStorage.getItem("vonage_userid");
                                        disp.meta01 = "";
                                      }
                                      else if(contact_center_type==="wxcc"){
                                        disp.meta00 = sessionStorage.getItem("wxcc_agentId");
                                        disp.meta01 = "";
                                      } 
                                     else {
                                         disp.meta00 = agentId;
                                         disp.meta01 = teamName;
                                         disp.dial_list_uid = state$.value.choosecaller?.callId;
                                     }
                                     disp.meta02 = dataresponse.opened_for;
                                     actions.push(pushToDisposition(disp));
                                 }
                            return actions;
                        })
                        // map((response: any) => setAction(response))
                    )
            })
        )
    }
);
/**
 * This Fuction will clear data of pending referals epic
 * subsequent redux action
 * @param context contains the settings,logger etc..
 */
export const clearInteractionsEpic = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget,incidents-epic",
            "Reset-Referrals-epic", {
        });
        return action$.pipe(
            ofType(patientSET, RESET),
            map(action => reinitAction())
        )
    }
);

